// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design';
import axios from 'axios'
Vue.prototype.$ajax = axios
// import style
import 'view-design/dist/styles/iview.css';


Vue.config.productionTip = false

Vue.use(ViewUI);
Vue.config.productionTip = false
// Vue.prototype.$qs = qs
axios.defaults.withCredentials=true;//让ajax携带cookie

console.log(process.env.API_ROOT)
console.log(process.env.NODE_ENV)
// console.log(process.env.VUE_APP_SERVICE_URL)
import {post,get} from './untils/http.js'

Vue.prototype.post = post;
Vue.prototype.get = get;
// Vue.prototype.baseURL = process.env.API_ROOT;
// 设置请求头
axios.defaults.headers.post["Content-type"] = "application/json"
// axios.interceptors.request.use(
//   config => {
// 	  	var testUrl =  config.url
//     if(testUrl == "api/mark/number/add"  || testUrl == "api/mark/number/delete" ||testUrl == "api/mark/record/lottery"||testUrl == "api/mark/record/add" || testUrl == "api/mark/picture/add" || testUrl == "api/mark/picture/delete"|| testUrl == "api/mark/picture/addImg"){
//         var token  = window.sessionStorage.getItem('token')
//     	 if (token) {
//        console.log('加了token')
//        // config.headers.Authorization = window.sessionStorage.getItem('token')
//        config.headers.common['token'] = window.sessionStorage.getItem('token')
//      
//      }else{
//     		console.log('没有token')  
//     		}
//     }else{
//     	  console.log('不用加token')  
//     }
//     return config;
//   },
//   err => {
//     return Promise.reject(err);
//   });


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js